import styles from "./pageLink.module.css";
import TextWrapper from "../textWrapper/TextWrapper";
import { NavLink } from "react-router-dom";

const PageLink = ({ image, icon: Icon, children, destination }) => {
  return (
    <NavLink
      to={destination}
      className={({ isActive }) => {
        return isActive
          ? `${styles.container} ${styles.active}`
          : styles.container;
      }}
    >
      <TextWrapper textStyle="textXSmall">{children}</TextWrapper>
      {Icon ? (
        <Icon className={styles.icon} />
      ) : image ? (
        <img src={image} alt="icon placeholder" />
      ) : null}
    </NavLink>
  );
};

export default PageLink;
